import {IPropiedadesForma} from "../../interfaces/IPropiedadesForma";
import {Colonia} from "../catalogos/Colonia";
import {Sucursal} from "../catalogos/Sucursal";
import {ServicioAdicional} from "../catalogos/ServicioAdicional";
import {ICatalogo} from "../catalogos/ICatalogo";
import {ITipoEnvio} from "../catalogos/ITipoEnvio";
import {IRecoleccion} from "../../redux/types/recoleccionActionTypes";
import {enums} from "../../enums/enums";
import {Mercancia} from "./Mercancia";
import {Facturador} from "../catalogos/Facturador";
import {Proyecto} from "../catalogos/Proyecto";
import {Contacto} from "../catalogos/Contacto";
import {ICliente} from "../catalogos/ICliente";
import {IDocumento} from "../catalogos/IDocumento";
import { traducirMessage } from "../../blocks/traductor";
import { IIntraUSA } from "../../components/origenDestino/IntraUSA";
import { CruceInternacional } from "../catalogos/CruceInternacional";

export interface ISolicitud extends IPropiedadesForma {
    solicitudId?: number
    estatusId: number
    seccionId: number
    paisIdOrigen: number
    paisIdDestino: number
    coloniaOrigen?: Colonia
    ocurreOrigen?: 0 | 1
    areaServicioOrigenId?: number
    tipoRecoleccionIdOrigen?: number
    sucursalOrigen?: Sucursal
    serviciosAdicionalesOrigen?: ServicioAdicional[]
    coloniaDestino?: Colonia
    ocurreDestino?: 0 | 1
    areaServicioDestinoId?: number
    tipoRecoleccionIdDestino?: number
    sucursalDestino?: Sucursal
    serviciosAdicionalesDestino?: ServicioAdicional[]
    tipoServicio?: ICatalogo
    tipoEnvio?: ITipoEnvio
    tipoEnvioId?: number
    esRad?: boolean
    fechaCitaRad?: Date
    fechaRecoleccion?: Date
    esEad?: boolean
    unidadMedidaLongitudId?: number
    unidadMedidaPesoId?: number
    fechaCitaEad?: Date
    esSeguroBasico: boolean
    esSeguroMercancia: boolean
    esCobrarEnDestino?: boolean
    valorMercancia?: number | null
    monedaId?: number
    mercancias?: Mercancia[]
    serviciosAdicionales?: ServicioAdicional[]
    markupMonto?: number | null
    markupPorcentaje?: number | null
    tipoMarkupId?:number
    completada?: boolean
    completadaMarkup?: boolean
    total?: number
    subtotal?: number
    iva?: number
    retencion?: number
    descuento?: number
    cotizacionId?: number
    totalPesoFacturado?: number
    totalPesoMercancia?: number
    totalPesoVolumen?: number
    costoSeguro: number
    costoMarkup: number
    claseId?: number
    clase: string
    facturador?: Facturador
    proyecto?: Proyecto
    tipoSolicitud?: string
    contactoOrigen?: Contacto
    contactoDestino?: Contacto
    observaciones?: string
    numGuia?: string
    correo?: string
    empresaTarifaAlmex?: string
    nombreTarifaAlmex?: string
    telefonoTarifaAlmex?: string
    esParticularTarifaAlmex?: number
    modificar?: boolean
    direccionRemitente?: string
    direccionDestinatario?: string
    distribuidorRemitente?: any
    distribuidorDestinatario?: any
    clienteReferencias?: any[]
    archivosAdjuntos?: any[]
    horariosOrigen?: any[]
    horariosDestino?: any,
    esResidencialOrigen?: boolean,
    esResidencialDestino?: boolean,
    descripcionMercancia?: string,
    EsRadCitaFueraHorario?: boolean,
    RadCitaHoraDe?: string,
    RadCitaHoraHasta?: string,
    EsEadCitaFueraHorario?: boolean,
    EsEadCita?:boolean,
    tipoDocumento?:number,
    EsRadCita?:boolean,
    EadCitaHoraDe?: string,
    EadCitaHoraHasta?: string,
    tieneCruceFronterizo?: boolean,
    cotizacionCitaHorario?: any,
    montoPesoFacturado?: number
    fechaAlta?: Date
    esSolicitarDeNuevo?: boolean,
    esDetalle?:boolean,
    documentosRetorno?: IDocumento[],
    expandeDestinatario?:boolean,
    cargaServiciosState?:boolean,
    nombreInv?: string,
    apellidoInv?: string,
    //Cuando se imprime o se envía por correo una cotización o solictud de servicio se pone como true esta variable
    // y ya no permite volver a ninguna sección
    enviada?:boolean,
    fechaCitaRadCedis?: Date,
    fechaCitaEadCedis?: Date,
    tipoDeRecoleccionOrigen?: number,
    tipoDeRecoleccionDestino?: number,
    esSolicitarDeNuevoOrigen?: boolean,
    esSolicitarDeNuevoDestino?: boolean,
    tipoSeleccionDestino?: number
    esHomeDelivery?:boolean, 
    tipoServicioReal?: ICatalogo,
    esServicioInternacional?:boolean,
    esComercioExterior?: boolean,
    comercioExterior?: any,
    cruceFronterizo?: any,
    esCruceOrigen?: boolean,
    eliminaRetornoDocumentos?: boolean
}

export class Solicitud {
    constructor(props: ISolicitud) {
        Object.assign(this, props);
        this.esFormaValida = true;
        this.tieneCruceFronterizo = false;
        //this.esSolicitarDeNuevo = false;
        //this.esSolicitarDeNuevoDestino = false;
        //if(props.esSolicitarDeNuevoDestino!==undefined){
        //    this.esSolicitarDeNuevoDestino = props.esSolicitarDeNuevoDestino;
        //}
        this.enviada = false;
    }

    SetValores(solicitud, esCotizacion: boolean, obtenerTotales: boolean) {
        const esRad = esCotizacion ? solicitud.esRAD === 1 : solicitud.esRad === 1;
        const esEad = esCotizacion ? solicitud.esEAD === 1 : solicitud.esEad === 1;
        const esOcurreOrigen = esCotizacion ? solicitud.ocurreOrigen === 1 : solicitud.esOcurreOrigen === 1;
        const esOcurreDestino = esCotizacion ? solicitud.ocurreDestino === 1 : solicitud.esOcurreDestino === 1;
        if(solicitud.cotizacionMarkupSeleccion!==null && solicitud.cotizacionMarkupSeleccion!==undefined){
            this.tipoMarkupId = solicitud.cotizacionMarkupSeleccion.tipoSeleccion;
        }
        if(solicitud.solicitudServicioMarkupSeleccion!==null && solicitud.solicitudServicioMarkupSeleccion!==undefined && !esCotizacion){
            this.tipoMarkupId = solicitud.solicitudServicioMarkupSeleccion.tipoSeleccion;
        }
        this.proyecto = {
            id: solicitud.proyectoID,
            descripcion: (solicitud.grupoProyecto===null)?solicitud.proyecto?.descripcion??"": solicitud.grupoProyecto?.nombre??""
        }
        this.cotizacionCitaHorario=solicitud.cotizacionCitaHorario;
        this.EsRadCitaFueraHorario = solicitud.esRadCitaFueraHorario;
        this.EsEadCitaFueraHorario=solicitud.esEadCitaFueraHorario;
        const citaFueraRAD=solicitud.esRadCitaFueraHorario;
        if(citaFueraRAD  )
        {

            if(solicitud.cotizacionCitaHorario!=null)
            {
                const radInicio=new Date(solicitud.cotizacionCitaHorario.radCitaHoraInicio);
                const radFin=new Date(solicitud.cotizacionCitaHorario.radCitaHoraFinal);
                this.RadCitaHoraDe = this.zeroPad(radInicio.getHours(),2) +':'+this.zeroPad(radInicio.getMinutes(),2) ;
                this.RadCitaHoraHasta = this.zeroPad(radFin.getHours(),2) +':'+ this.zeroPad(radFin.getMinutes(),2) ;
            }
            else {

                const radInicio=new Date(solicitud.radCitaHoraDe);
                const radFin=new Date(solicitud.radCitaHoraHasta);
                this.RadCitaHoraDe = this.zeroPad(radInicio.getHours(),2) +':'+this.zeroPad(radInicio.getMinutes(),2) ;
                this.RadCitaHoraHasta = this.zeroPad(radFin.getHours(),2) +':'+ this.zeroPad(radFin.getMinutes(),2) ;
            }
        }

        const citaFueraEAD=solicitud.esEadCitaFueraHorario;
        if(citaFueraEAD  )
        {
            if(solicitud.cotizacionCitaHorario != null)
            {
                const eadInicio=new Date(solicitud.cotizacionCitaHorario.eadCitaHoraInicio);
                const eadFin=new Date(solicitud.cotizacionCitaHorario.eadCitaHoraFinal);
                this.EadCitaHoraDe= this.zeroPad(eadInicio.getHours(),2) +':'+ this.zeroPad(eadInicio.getMinutes(),2) ;
                this.EadCitaHoraHasta=this.zeroPad(eadFin.getHours(),2) +':'+this.zeroPad(eadFin.getMinutes(),2) ;
            }
            else {
                const eadInicio=new Date(solicitud.eadCitaHoraDe);
                const eadFin=new Date(solicitud.eadCitaHoraHasta);
                this.EadCitaHoraDe= this.zeroPad(eadInicio.getHours(),2) +':'+ this.zeroPad(eadInicio.getMinutes(),2) ;
                this.EadCitaHoraHasta=this.zeroPad(eadFin.getHours(),2) +':'+this.zeroPad(eadFin.getMinutes(),2) ;
            }
        }

        this.esResidencialOrigen=solicitud.esResidencialOrigen;
        this.esResidencialDestino=solicitud.esResidencialDestino;
        this.EsEadCita=solicitud.esEadCita;
        this.EsRadCita=solicitud.esRadCita;
        this.completada = esCotizacion;
        this.modificar = !esCotizacion;
        this.completadaMarkup = esCotizacion;
        this.areaServicioDestinoId = solicitud.areaServicioDestinatarioID;
        this.areaServicioOrigenId = solicitud.areaServicioRemitenteID;
        this.claseId = solicitud.claseID;
        this.clase = solicitud.clase.nombre;
        this.esSeguroBasico = solicitud.esSeguroBasico === 1;
        this.esSeguroMercancia = solicitud.esSeguroMercancia === 1;
        this.valorMercancia = solicitud.valorMercancia !== null ? solicitud.valorMercancia : 0;
        this.unidadMedidaPesoId = solicitud.unidadMedidaMercanciaID;
        this.unidadMedidaLongitudId = solicitud.unidadMercanciaID;
        this.serviciosAdicionales = solicitud.serviciosAdicionales;
        this.cotizacionId = solicitud.cotizacionID;
        this.solicitudId = esCotizacion ? solicitud.cotizacionID : 0;
        this.id = esCotizacion ? solicitud.cotizacionID : 0;
        this.correo = solicitud.correo;
        this.tipoRecoleccionIdOrigen=enums.tipoRecoleccion.comercial;
        if(solicitud.esResidencialOrigen==true)
        {
            this.tipoRecoleccionIdOrigen=enums.tipoRecoleccion.residencial;
        }
        if(esOcurreOrigen==true)
        {
            this.tipoRecoleccionIdOrigen=enums.tipoRecoleccion.ocurre;
        }
        this.tipoRecoleccionIdDestino=enums.tipoRecoleccion.comercial;
        if(solicitud.esResidencialDestino==true)
        {
            this.tipoRecoleccionIdDestino=enums.tipoRecoleccion.residencial;
        }
        if(esOcurreDestino==true)
        {
            this.tipoRecoleccionIdDestino=enums.tipoRecoleccion.ocurre;
        }
        this.tipoEnvio = solicitud.tipoEnvio;
        this.nombreTarifaAlmex = solicitud.nombreTarifaAlmex;
        this.empresaTarifaAlmex = solicitud.empresaTarifaAlmex;
        this.telefonoTarifaAlmex = solicitud.telefonoTarifaAlmex;
        this.esParticularTarifaAlmex = solicitud.empresaTarifaAlmex !== null && solicitud.empresaTarifaAlmex !== "" ? 2 : 1;
        this.tipoServicio = solicitud.tipoServicio;
        this.tipoSolicitud = esCotizacion ? "cotizacion" : "solicitud servicio";
        this.sucursalOrigen = solicitud.sucursalRemitente;
        this.sucursalDestino = solicitud.sucursalDestinatario;
        this.direccionRemitente = solicitud.direccionRemitente;
        this.direccionDestinatario = solicitud.direccionDestinatario;
        this.markupMonto = Number(solicitud.markupMonto ?? 0);
        this.markupPorcentaje = Number(solicitud.markupPorcentaje ?? 0);
        this.fechaAlta = solicitud.fechaAlta;
        if(solicitud.fechaCitaRAD==null)
            this.fechaCitaRad=undefined;
        else
        {
            const fRAD=new Date(solicitud.fechaCitaRAD).toUTCString();
            this.fechaCitaRad=new Date(fRAD);
            const fechaDefaultEAD = new Date('1900-01-01T00:00:00');
            if(fechaDefaultEAD.getFullYear()==this.fechaCitaRad.getFullYear())
                this.fechaCitaRad=undefined;
        }

        if(esCotizacion && solicitud.cotizacionRadEadCedis.esRadCitaCedis !== undefined && solicitud.cotizacionRadEadCedis.esRadCitaCedis){
            const fRAD=new Date(solicitud.cotizacionRadEadCedis.fechaCitaRADCedis).toUTCString();
            this.fechaCitaRadCedis=new Date(fRAD);    
        }
        if(solicitud.fechaCitaEAD==null)
            this.fechaCitaEad=undefined;
        else {
            const fEAD=new Date(solicitud.fechaCitaEAD).toUTCString();
            this.fechaCitaEad=new Date(fEAD);
            const fechaDefault = new Date('1900-01-01T00:00:00');
            if(fechaDefault.getFullYear()==this.fechaCitaEad.getFullYear())
                this.fechaCitaEad=undefined;
        }
        if(esCotizacion && solicitud.cotizacionRadEadCedis.esEadCitaCedis !== undefined && solicitud.cotizacionRadEadCedis.esEadCitaCedis){
            const fRAD=new Date(solicitud.cotizacionRadEadCedis.fechaCitaEADCedis).toUTCString();
            this.fechaCitaEadCedis=new Date(fRAD);    
        }
        this.numGuia = solicitud.numGuia;

        this.contactoOrigen = this.SetContactoDistribuidor(solicitud.contactoRemitente);
        this.contactoDestino = this.SetContactoDistribuidor(solicitud.contactoDestinatario);

        if (solicitud.coloniaOrigen != null || solicitud.distribuidorRemitente?.colonium != null) {
            const colonia = solicitud.coloniaOrigen ?? solicitud.distribuidorRemitente.colonium;
            this.coloniaOrigen = new Colonia(colonia);
        }

        if (solicitud.coloniaDestino != null || solicitud.distribuidorDestinatario?.colonium != null) {
            const colonia = solicitud.coloniaDestino ?? solicitud.distribuidorDestinatario.colonium;
            this.coloniaDestino = new Colonia(colonia);
        }

        if(solicitud.facturador){
            this.facturador = {
                id: solicitud.facturador.id,
                clienteNombre: solicitud.facturador.nombre,
                clienteRFC: solicitud.facturador.rfc
            }
        }

        if (obtenerTotales) {
            this.totalPesoMercancia = solicitud.totalPesoMercancia;
            this.totalPesoFacturado = solicitud.totalPesoFacturado;
            this.montoPesoFacturado = this.GetTotalPesoFacturado(solicitud, esCotizacion);
            this.total = solicitud.total;
            this.iva = solicitud.iva;
            this.subtotal = solicitud.subTotal;
            this.totalPesoVolumen = solicitud.totalPesoVolumen;
            this.costoSeguro = solicitud.cotizacionDesgloseFleteSeguro != undefined && solicitud.cotizacionDesgloseFleteSeguro.length > 0 ?
                solicitud.cotizacionDesgloseFleteSeguro[0].valor : 0;
        }
        this.esHomeDelivery = solicitud.esHomeDelivery;
        this.tipoServicioReal = solicitud.tipoServicioReal;
        this.comercioExterior = this.GetComercioExterior(solicitud);
        this.cruceFronterizo = this.GetCruceFronterizo(solicitud);
        this.esServicioInternacional = (this.cruceFronterizo != undefined && this.cruceFronterizo != null );
        this.esComercioExterior = (this.comercioExterior != undefined && this.comercioExterior != null);
        this.esCruceOrigen = (this.paisIdOrigen === enums.pais.usa);
    }


    ValidarCotizacion(cotizacion, cliente: ICliente, clienteValido: boolean): string {
        let error = "";

        if (!clienteValido || cotizacion.estatusCotizacionID === 2) {
            error = clienteValido ? traducirMessage(142) :
                traducirMessage(48)
            return error;
        }

        let mesAnterior = new Date();
        mesAnterior.setMonth(mesAnterior.getMonth() - 1);
        mesAnterior = new Date(mesAnterior.toDateString());

        const tarifaVencida = new Date(cotizacion.fechaAlta) < mesAnterior;
        const clienteId = cotizacion.cliente?.id ?? cliente.id;
        const clienteCreditoInvalido = cliente?.clienteCredito != null
            && cliente.clienteCredito.esSuspendido
            && cliente.clienteCredito.tipoPagoID === enums.tipoPago.credito;

        if (clienteId !== cliente.id || clienteCreditoInvalido || tarifaVencida) {
            error = clienteCreditoInvalido ?
                traducirMessage(49)
                : tarifaVencida ? traducirMessage(140)
                    : traducirMessage(139);
        }

        return error;
    }

    SetId(id: number) {
        this.id = id;
    }

    SetContactoDistribuidor(contactoDistribuidor): Contacto | undefined {
        if (contactoDistribuidor != null) {
            return new Contacto({
                id: contactoDistribuidor.clienteDistribuidorContactoID,
                nombre: contactoDistribuidor.nombreClienteDistribuidorContacto,
                telefono: contactoDistribuidor.telefono,
                correo: contactoDistribuidor.correo,
            })
        }

        return undefined;
    }

    SetColonia(contactoDistribuidor): Contacto | undefined {
        if (contactoDistribuidor != null) {
            return new Contacto({
                id: contactoDistribuidor.clienteDistribuidorContactoID,
                nombre: contactoDistribuidor.nombreClienteDistribuidorContacto,
                telefono: contactoDistribuidor.telefono,
                correo: contactoDistribuidor.correo,
            })
        }

        return undefined;
    }

    SetContactoOrigen(contacto: any) {
        this.contactoOrigen = contacto;
    }

    SetContactoDestino(contacto: any) {
        this.contactoDestino = contacto;
    }

    SetDistribuidorRemitente(distribuidor: any) {
        this.distribuidorRemitente = distribuidor;
    }

    SetDistribuidorDestinatario(distribuidor: any) {
        this.distribuidorDestinatario = distribuidor;
    }

    SetDistribuidorRemitenteCoordenadas(latitude: number, longitude: number) {
        this.distribuidorRemitente.latitude = latitude;
        this.distribuidorRemitente.longitude = longitude;
    }

    SetDistribuidorDestinatarioCoordenadas(latitude: number, longitude: number) {
        this.distribuidorDestinatario.latitude = latitude;
        this.distribuidorDestinatario.longitude = longitude;
    }

    SetOrigen(origen: IRecoleccion) {
        this.paisIdOrigen = origen.paisId;
        this.coloniaOrigen = origen.colonia;
        this.fechaCitaRad = origen.fechaCita;
        this.fechaRecoleccion = origen.fechaRecoleccion;
        this.tipoRecoleccionIdOrigen = origen.tipoRecoleccionId;
        this.serviciosAdicionalesOrigen = origen.serviciosAdicionales;
        this.areaServicioOrigenId = origen.areaServicio?.id;
        this.sucursalOrigen = origen.sucursal;
        this.horariosOrigen = origen.areaServicio?.horarios;
        this.SetTipoRecoleccion(origen.tipoRecoleccionId, true);
        this.EsRadCitaFueraHorario = origen.EsFueraHorario;
        this.RadCitaHoraDe = origen.horaFHDe;
        this.RadCitaHoraHasta = origen.horaFHHasta;
        this.direccionRemitente = origen.distribuidor?.direccion?? "";
        this.fechaCitaRadCedis = origen.fechaCitaCedis;
        if(origen.EsCitaRadCedis && origen.fechaCita !== undefined){
            this.fechaCitaRadCedis = origen.fechaCita;    
            this.fechaCitaRad = undefined;
        }
    }

    SetDestino(destino: IRecoleccion) {
        this.paisIdDestino = destino.paisId;
        this.coloniaDestino = destino.colonia;
        this.fechaCitaEad = destino.fechaCita;
        this.tipoRecoleccionIdDestino = destino.tipoRecoleccionId;
        this.serviciosAdicionalesDestino = destino.serviciosAdicionales;
        this.areaServicioDestinoId = destino.areaServicio?.id;
        this.sucursalDestino = destino.sucursal;
        this.horariosDestino = destino.areaServicio?.horarios;
        this.SetTipoRecoleccion(destino.tipoRecoleccionId, false);
        this.EsEadCitaFueraHorario = destino.EsFueraHorario;
        this.EadCitaHoraDe = destino.horaFHDe;
        this.EadCitaHoraHasta = destino.horaFHHasta;
        this.direccionDestinatario = destino.distribuidor?.direccion?? "";
        this.fechaCitaEadCedis = destino.fechaCitaCedis;
        if(destino.EsCitaEadCedis && destino.fechaCita !== undefined){
            this.fechaCitaEadCedis = destino.fechaCita;    
            this.fechaCitaEad = undefined;
        }
        this.esHomeDelivery = destino.esHomeDelivery;
    }

    SetPropiedadRecoleccion(propiedad: string, value: any, esOrigen: boolean) {
        if (esOrigen && propiedad == "fechaCita") {
            this["fechaCitaRad"] = value;
        }
        if (!esOrigen && propiedad == "fechaCita") {
            this["fechaCitaEad"] = value;
        }
        if (esOrigen && propiedad == "fechaCitaCedis") {
            this["fechaCitaRadCedis"] = value;
        }
        if (!esOrigen && propiedad == "fechaCitaCedis") {
            this["fechaCitaEadCedis"] = value;
        }
        if (propiedad == "fechaRecoleccion") {
            delete this['fechaCitaRad'];
            delete this['fechaCitaRadCedis'];
        }

        delete this['RadCitaHoraDe'];
        delete this['RadCitaHoraHasta'];
        delete this['EadCitaHoraDe'];
        delete this['EadCitaHoraHasta'];
        delete this['EsRadCitaFueraHorario'];
        delete this['EsEadCitaFueraHorario'];

        if (propiedad.indexOf("tipoRecoleccion") !== -1)
            this.SetTipoRecoleccion(value, esOrigen);

        this[propiedad] = value;
    }

    SetPropiedadRecoleccionFH(propiedad: string, value: any, propiedad2: string, value2: any,
                              propiedad3: string, value3: any, esOrigen: boolean, esSolicitud: boolean) {
        if (esSolicitud) {
            if (esOrigen && propiedad == "fechaCita" && (value2 == null && value3 == null)) {
                this["fechaCitaRad"] = value;
                this["RadCitaHoraDe"] = value2;
                this["RadCitaHoraHasta"] = value3;
                delete this['EsRadCitaFueraHorario'];
            }
            if (!esOrigen && propiedad == "fechaCita" && (value2 == null && value3 == null)) {
                this["fechaCitaEad"] = value;
                this["EadCitaHoraDe"] = value2;
                this["EadCitaHoraHasta"] = value3;
                delete this['EsEadCitaFueraHorario'];
            }
        } else {
            if (esOrigen && propiedad == "fechaCita" && (value2 == null && value3 == null)) {
                this["fechaCitaRad"] = value;
                this["RadCitaHoraDe"] = value2;
                this["RadCitaHoraHasta"] = value3;
                this['EsRadCitaFueraHorario'] = true;
            }
            if (!esOrigen && propiedad == "fechaCita" && (value2 == null && value3 == null)) {
                this["fechaCitaEad"] = value;
                this["EadCitaHoraDe"] = value2;
                this["EadCitaHoraHasta"] = value3;
                this['EsEadCitaFueraHorario'] = true;
            }
        }

        if (esOrigen && propiedad == "fechaCita" && (value2 != null && value3 != null)) {
            this["fechaCitaRad"] = value;
            this["RadCitaHoraDe"] = value2;
            this["RadCitaHoraHasta"] = value3;
            this["EsRadCitaFueraHorario"] = true;
        }

        if (!esOrigen && propiedad == "fechaCita" && (value2 != null && value3 != null)) {
            this["fechaCitaEad"] = value;
            this["EadCitaHoraDe"] = value2;
            this["EadCitaHoraHasta"] = value3;
            this["EsEadCitaFueraHorario"] = true;
        }

        if (propiedad == "fechaRecoleccion") {
            delete this['fechaCitaRad'];
            delete this['RadCitaHoraDe'];
            delete this['RadCitaHoraHasta'];
            delete this['EadCitaHoraDe'];
            delete this['EadCitaHoraHasta'];
            delete this['EsRadCitaFueraHorario'];
            delete this['EsEadCitaFueraHorario'];
        }

        if (propiedad.indexOf("tipoRecoleccion") !== -1)
            this.SetTipoRecoleccion(value, esOrigen);
    }

    SetServiciosAdicionales(servicios: ServicioAdicional[]) {
        this.serviciosAdicionales = servicios != null ? servicios.filter(s => s.seleccionado !== undefined && s.seleccionado) : [];
    }

    SetTipoEnvio(tipo: any) {
        this.tipoEnvio = tipo;
    }

    SetCompletada() {
        this.completada = true;
    }

    SetCompletadaMarkup() {
        this.completada = true;
    }

    AgruparServicios(servicios: ServicioAdicional[]) {
        const servicioAdicionales = servicios != null ? servicios.filter(s => s.seleccionado) : [];
        let serviciosOrigenDestino: ServicioAdicional[] = [];

        const serviciosOrigen = this.serviciosAdicionalesOrigen != null ?
            this.serviciosAdicionalesOrigen.filter(s => s.seleccionado) : [];

        const serviciosDestino = this.serviciosAdicionalesDestino != null ?
            this.serviciosAdicionalesDestino.filter(s => s.seleccionado) : [];

        if (serviciosOrigen.length) {
            //Agrega los servicios seleccionados en el origen, y si coincide con un servicio seleccionado en el destino se setea la propiedad aplicaDestino
            serviciosOrigen.forEach(s => {
                const copiaServicio = new ServicioAdicional(s);
                copiaServicio.aplicaOrigen = true;
                if (serviciosDestino.some(sd => sd.id === s.id)) {
                    copiaServicio.aplicaDestino = true
                }
                serviciosOrigenDestino.push(copiaServicio);
            });
        }


        if (serviciosDestino.length) {
            //Agrega los servicios seleccionados en el destino, pero solo los que no coinciden con los servicos de origen
            serviciosDestino.forEach(s => {
                const copiaServicio = new ServicioAdicional(s);
                if (!serviciosOrigen.some(so => so.id === s.id)) {
                    copiaServicio.aplicaDestino = true;
                    serviciosOrigenDestino.push(copiaServicio);
                }
            });
        }

        this.serviciosAdicionales = [...serviciosOrigenDestino, ...servicioAdicionales]

        const retornoDocumentos = this.serviciosAdicionales.find(e=> e.esRetornoDocumentos && e.seleccionado);

        if(retornoDocumentos != null){
            this.documentosRetorno = retornoDocumentos.documentos;
        }
    }

    private SetTipoRecoleccion(tipoRecoleccionId: number | undefined, esOrigen: boolean) {
        if (esOrigen) {
            this.ocurreOrigen = tipoRecoleccionId === enums.tipoRecoleccion.ocurre ? 1 : 0;
            this.esRad = tipoRecoleccionId === enums.tipoRecoleccion.comercial;
        } else {
            this.ocurreDestino = tipoRecoleccionId === enums.tipoRecoleccion.ocurre ? 1 : 0;
            this.esEad = tipoRecoleccionId === enums.tipoRecoleccion.comercial;
        }
    }

    SetSeguro(esBasico: boolean, excluirSeguro: boolean) {
        this.esSeguroBasico = esBasico && (!this.esSeguroBasico || !excluirSeguro);
        //this.esSeguroMercancia = !esBasico && (!this.esSeguroMercancia || !excluirSeguro);
    }

    ValidarValorMercancia(valorMinimo: number, valorMaximo: number
        , esExcluirSeguro: boolean) {
        this.esFormaValida = this.esSeguroBasico
            || (this.valorMercancia != null
                && this.valorMercancia >= valorMinimo
                && this.valorMercancia <= valorMaximo)
            || (!this.esSeguroBasico
                && !this.esSeguroMercancia
                && esExcluirSeguro);
    }

    CopiarSeccionMercancia(solicitudCopia: Solicitud) {
        this.unidadMedidaLongitudId = solicitudCopia.unidadMedidaLongitudId;
        this.unidadMedidaPesoId = solicitudCopia.unidadMedidaPesoId;
        this.esSeguroBasico = solicitudCopia.esSeguroBasico;
        this.esSeguroMercancia = solicitudCopia.esSeguroMercancia;
        this.valorMercancia = solicitudCopia.valorMercancia ? solicitudCopia.valorMercancia : 0;

    }

    CopiarMarkup(solicitudCopia: Solicitud) {
        this.markupMonto = solicitudCopia.markupMonto;
        this.markupPorcentaje = solicitudCopia.markupPorcentaje;
    }

    SetPropiedad(propiedad: string, value: any) {
        this[propiedad] = value;
    }

    SetClienteReferencias(referencias: any) {
        this.SetClienteReferencias = referencias;
    }

    SetComercioExterior(comext: any){
        if(comext == undefined || comext == null ){
            this.esComercioExterior = false;
            this.esServicioInternacional = false;
            this.tieneCruceFronterizo = false;
            this.comercioExterior = null;
        }
        else{
            this.esComercioExterior = true;
            this.comercioExterior = comext;
        }
    }

    SetCruceFronterizo(cruce: any){
        if(cruce == undefined || cruce == null){
            this.esServicioInternacional = false;
            this.tieneCruceFronterizo = false;
            this.cruceFronterizo = null;
        }
        else{
            this.esServicioInternacional = true;
            this.tieneCruceFronterizo = true;
            this.cruceFronterizo = cruce;
        }
    }

    GetTotalPesoFacturado = (solicitud, esCotizacion: boolean) => {
        let total = 0;
        const deesgloseFlete = esCotizacion ? solicitud.cotizacionDesgloseFlete : solicitud.solicitudDesgloseFlete;
        const deesgloseFleteEad = esCotizacion ? solicitud.cotizacionDesgloseFleteEad : solicitud.solicitudDesgloseFleteEad;
        const deesgloseFleteRad = esCotizacion ? solicitud.cotizacionDesgloseFleteRad : solicitud.solicitudDesgloseFleteRad;
        const desgloseFleteAjuste = esCotizacion ? solicitud.cotizacionDesgloseFleteAjuste : solicitud.solicitudDesgloseFleteAjuste
        const serviciosAdicionales = esCotizacion ? solicitud.serviciosAdicionales : solicitud.solicitudConceptos
        if (deesgloseFlete.length) {
            total = (deesgloseFlete.reduce((a,v) => a = a + v.valor, 0));
        }
        if (deesgloseFleteEad.length) {
            total += deesgloseFleteEad[0].valor;
        }
        if (deesgloseFleteRad.length) {
            total += deesgloseFleteRad[0].valor;
        }
        if(desgloseFleteAjuste.length) {
            total += desgloseFleteAjuste[0].valor;
        }
        if (Array.isArray(serviciosAdicionales) && serviciosAdicionales.length > 0) {
            for (let i = 0; i < serviciosAdicionales.length; i++) {
                if (serviciosAdicionales[i].id === 480) {
                    total += serviciosAdicionales[i].costo;
                }
                if (serviciosAdicionales[i].id === 479) {
                    total += serviciosAdicionales[i].costo;
                }
            }
        }
        return total;
    }

    zeroPad = (num, places)=> {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
    }

    GetComercioExterior = (solicitud) => {
        const comext = solicitud.cotizacionComercioExterior ?? solicitud.solicitudServicioComercioExterior;
        if(comext === undefined || comext === null){
            return null;
        }
        else{
            return ({ 
                solicitudComercioExteriorId : comext.cotizacionComercioExteriorId ?? comext.solicitudServicioComercioExteriorId,
                solicitudId : comext.cotizacionId ?? comext.solicitudServicioId,
                tipoComercioExteriorId : comext.tipoComercioExteriorId 
            });
        }
    }

    GetCruceFronterizo = (solicitud) => {
        let cruce = solicitud.cotizacionCruceFronterizo ?? solicitud.solicitudServicioCruceFronterizo;
        if(cruce === undefined || cruce === null){
            return null;
        }
        else{
            return {
                solicitudComercioExteriorId : cruce.cotizacionComercioExteriorId ?? cruce.solicitudServicioComercioExteriorId,
                tipoServicioInternacionalId : cruce.tipoServicioInternacionalId,
                tipoMovimientoServicioInternacionalId : cruce.tipoMovimientoServicioInternacionalId,
                cruceInternacionalId : cruce.cruceInternacionalId ?? 0,
                esIntraUSA : cruce.esIntraUSA,
                solicitudId : cruce.cotizacionId ?? cruce.solicitudServicioId,
                sucursalId: cruce.cruceInternacional?.sucursalID ?? 0,
                cruce: cruce.cruceInternacional?.cruce ?? ''
            };
        }
    }
}

export interface Solicitud extends ISolicitud {
}
